import React, { Children } from 'react'
import styled from 'styled-components'
import { Field } from 'react-final-form'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

const EditorWrapper = styled.div`
  ${({error}) => `
    border: solid 1px ${error ? 'red' : 'white'}
  `}
`

const WysiwygEditor = ({
  id,
  type,
  name,
  label,
  helperText,
  validate,
  renderAfterEditor,
  text
}) => (
  <Field
    name={name}
    type={type}
    validate={validate}
  >
    {({ input, meta }) => {
      const {
        onChange,
        value
      } = input
      return (
        <EditorWrapper
          error={meta.error}
        >
          <CKEditor
            editor={ ClassicEditor }
            data={value}
            config={{
              removePlugins: [ ],
              toolbar: [ 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link' ]
            }}
            onChange={( event, editor ) => {
                onChange(editor.getData())
            }}
          />
          {renderAfterEditor && typeof renderAfterEditor === 'function' && renderAfterEditor(onChange)}
        </EditorWrapper>
      )
    }}
  </Field>
)

export default WysiwygEditor